"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = Dropdown;
var _symbols = require("@a1s/symbols");
var _theme = require("@a1s/theme");
var _hashSum = _interopRequireDefault(require("hash-sum"));
var _nanoid = require("nanoid");
var _react = _interopRequireWildcard(require("react"));
var _polished = require("polished");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _state = require("./state");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
/**
 * The "X" that removes a selection from the `values` list.
 */
const CloseButton = _styledComponents.default.button`
  align-items: center;
  appearance: none;
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  height: ${(0, _polished.rem)((0, _theme.rhythmUnits)(1))};
  justify-content: center;
  width: ${(0, _polished.rem)((0, _theme.rhythmUnits)(1))};

  &:hover path {
    fill: ${p => p.theme.colors.raisinBlack};
  }
`;

/**
 * The top-level wrapper componenent that contains the rest of the components.
 */
const Container = _styledComponents.default.div`
  cursor: text;
  position: relative;
  user-select: none;
  width: 100%;
`;

/**
 * Contains the main part of the component that is always visible, whether the component is expanded or collapsed. It
 * resembles all of the other form elements, including the `TextInput` component.
 */
const Control = _styledComponents.default.div`
  align-items: start;
  background-color: ${p => p.theme.colors.antiFlashWhite};
  border: ${p => p.theme.colors.antiFlashWhite} solid ${(0, _polished.rem)(2)};
  border-radius: ${p => (0, _polished.rem)(p.theme.radii[1])};
  display: flex;
  justify-content: space-between;
  position: relative;
  white-space: nowrap;
  z-index: 1;

  [aria-expanded='true'] > & {
    background-color: ${p => p.theme.colors.white};
    border-bottom: none;
    border-color: ${p => p.theme.colors.deepSkyBlue};
    border-radius: ${p => (0, _polished.rem)(p.theme.radii[1])} ${p => (0, _polished.rem)(p.theme.radii[1])} 0 0;
    box-shadow: ${({
  theme
}) => (0, _polished.transparentize)(0.92, theme.colors.raisinBlack)} 0 ${(0, _polished.rem)(4)} ${(0, _polished.rem)(8)};
  }
`;

/**
 * A component that lets the user know that this component is a dropdown component and can be exanded.
 */
const Expander = _styledComponents.default.div`
  cursor: pointer;
  padding: ${p => (0, _polished.rem)(p.theme.spacing[0])} ${p => (0, _polished.rem)(p.theme.spacing[1])};
  transform: translateY(2px);
`;

/**
 * Contains the search field, the placeholder, and the selected values.
 */
const InputArea = _styledComponents.default.div`
  color: ${p => p.theme.colors.raisinBlack};
  display: flex;
  flex-grow: 1;
  padding: ${p => (0, _polished.rem)(p.theme.spacing[0])} ${p => (0, _polished.rem)(p.theme.spacing[1])};
  position: relative;
`;

/**
 * Displayed when the user searches for something but there aren't any matches.
 */
const NoResults = _styledComponents.default.li`
  color: ${p => p.theme.colors.dimGrey};
  font-style: italic;
  padding: ${p => (0, _polished.rem)(p.theme.spacing[0])} ${p => (0, _polished.rem)(p.theme.spacing[1])};
`;

/**
 * An individual option that is displayed in the expanded part of the dropdown menu.
 */
const Option = _styledComponents.default.li`
  border-top: ${p => p.theme.colors.antiFlashWhite} solid ${(0, _polished.rem)(1)};
  cursor: pointer;
  padding: ${p => (0, _polished.rem)(p.theme.spacing[0])} ${p => (0, _polished.rem)(p.theme.spacing[1])};

  &:hover {
    background-color: ${p => p.theme.colors.antiFlashWhite};
  }

  &[aria-checked='true'] {
    display: none;
  }

  &[aria-selected='true'] {
    background-color: ${p => p.theme.colors.deepSkyBlue};
    color: ${p => p.theme.colors.white};
  }
`;

/**
 * Container component for all of the options.
 */
const Options = _styledComponents.default.ul`
  ${p => (0, _theme.adjustFontSizeTo)(p.theme.fontSizes[1])};

  align-items: stretch;
  background-color: ${p => p.theme.colors.white};
  backface-visibility: hidden;
  border: ${p => p.theme.colors.deepSkyBlue} solid ${(0, _polished.rem)(2)};
  border-radius: 0 0 ${p => (0, _polished.rem)(p.theme.radii[1])} ${p => (0, _polished.rem)(p.theme.radii[1])};
  border-top: none;
  bottom: calc(0 - 100%);
  box-shadow: ${({
  theme
}) => (0, _polished.transparentize)(0.92, theme.colors.raisinBlack)} 0 ${(0, _polished.rem)(4)} ${(0, _polished.rem)(8)};
  display: flex;
  flex-direction: column;
  list-style: none;
  max-height: ${(0, _polished.rem)((0, _theme.rhythmUnits)(9.4))};
  overflow-y: auto;
  position: absolute;

  width: 100%;
  z-index: 2;

  [aria-expanded='false'] > & {
    display: none;
  }
`;

/**
 * Displayed when there are no selected values and no text has been inputed in the search box.
 */
const Placeholder = _styledComponents.default.span`
  ${p => (0, _theme.adjustFontSizeTo)(p.theme.fontSizes[1])};

  color: ${p => p.theme.colors.dimGrey};
  position: absolute;
`;

/**
 * The input element for typing to filter the options.
 */
const SearchText = _styledComponents.default.input`
  ${p => (0, _theme.adjustFontSizeTo)(p.theme.fontSizes[1])};

  appearance: none;
  background-color: transparent;
  border: none;
  display: inline-block;
  font-family: ${p => p.theme.ui.baseFont};
  margin: 0;
  outline: 0;
  padding: 0;
`;

/**
 * Displays a selected value.
 */
const Selected = _styledComponents.default.span`
  ${p => (0, _theme.adjustFontSizeTo)(p.theme.fontSizes[1])};

  background-color: ${p => p.theme.colors.gainsboro};
  border: ${p => p.theme.colors.gainsboro} solid 1px;
  border-radius: ${(0, _polished.rem)(4)};
  color: ${p => p.theme.colors.raisinBlack};
  display: inline-flex;
  font-weight: 500;
  margin-bottom: ${p => (0, _polished.rem)(p.theme.spacing[0])};
  margin-right: ${p => (0, _polished.rem)(p.theme.spacing[0])};
  padding-left: ${p => (0, _polished.rem)(p.theme.spacing[0])};

  [aria-expanded='true'] & {
    background-color: ${p => p.theme.colors.antiFlashWhite};
  }
`;

/**
 * Wrapper component for displaying the selected values.
 */
const Selection = _styledComponents.default.div`
  ${p => (0, _theme.adjustFontSizeTo)(p.theme.fontSizes[1])};

  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${p => (0, _polished.rem)(-p.theme.spacing[0] - 2)};
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
/**
 * A component for selecting a value out of a list of options. It implements the [`combobox` aria role][combobox] which
 * is a widget made up of the combination of two distinct elements:
 * 1. a single-line textbox
 * 2. an associated pop-up element for helping users set the value of the textbox.
 *
 * [combobox]: https://www.w3.org/TR/wai-aria-practices/#combobox
 */
function Dropdown(props) {
  const {
    disabled,
    multiple = true,
    onChange,
    options,
    placeholder,
    testID,
    value = []
  } = props;
  const containerRef = (0, _react.useRef)(null);
  const idRef = (0, _react.useRef)((0, _nanoid.nanoid)());
  const inputRef = (0, _react.useRef)(null);
  const optionsRef = (0, _react.useRef)(null);
  const [state, dispatch] = (0, _react.useReducer)(_state.reducer, options, _state.initializer);

  /**
   * Make sure that the selected option is visible within the scroll container.
   */
  const makeSelectedVisible = (0, _react.useCallback)(() => {
    if (optionsRef.current) {
      const selected = optionsRef.current.querySelector('[role="option"][aria-selected="true"]');
      if (selected) {
        const optionBottom = selected.getBoundingClientRect().height + selected.offsetTop;
        const optionTop = selected.offsetTop;
        const scrollerBottom = optionsRef.current.getBoundingClientRect().height + optionsRef.current.scrollTop;
        const scrollerTop = optionsRef.current.scrollTop;
        if (optionTop < scrollerTop) {
          // Scroll up so the selected option is positioned at the top of the scroll container.
          optionsRef.current.scrollTo(0, optionTop);
        } else if (optionBottom > scrollerBottom) {
          // Scroll down so the selected option is positioned at the bottom of the scroll container.
          optionsRef.current.scrollTo(0, optionBottom - optionsRef.current.getBoundingClientRect().height);
        }
      }
    }
  }, [optionsRef]);

  /**
   * Since `value` is an array but we still need to know if _when_ the array has changed, we create a short hash of the
   * values using the `hash-sum` library. This hash can be used in the dependency list instead of the `value`
   * prop itself.
   */
  const __value = (0, _hashSum.default)(value);

  /**
   * Make sure that, if the `value` prop changes, that we're updating our internal state to reflect that.
   */
  (0, _react.useEffect)(() => {
    dispatch({
      payload: value.map(v => v.key),
      type: 'set-selected-keys'
    });
    // Use the hash of `value` instead of the `value` prop itself
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [__value]);

  /**
   * Manages and event handler for window-wide keyboard control of the `Dropdown` component.
   */
  (0, _react.useEffect)(() => {
    function handleKeyDown(event) {
      var _inputRef$current2;
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          dispatch({
            type: 'highlight-next-option'
          });
          makeSelectedVisible();
          break;
        case 'ArrowUp':
          event.preventDefault();
          dispatch({
            type: 'highlight-previous-option'
          });
          makeSelectedVisible();
          break;
        case 'Backspace':
          if (onChange && value.length > 0 && state.searchText === '') {
            dispatch({
              type: 'highlight-top-option'
            });
            onChange(value.slice(0, -1));
          }
          break;
        case 'Enter':
          {
            const highlighted = state.filteredOptions[state.highlightedFilteredOptionIndex];
            if (onChange && highlighted) {
              var _optionsRef$current, _optionsRef$current2;
              dispatch({
                type: 'highlight-top-option'
              });
              onChange(multiple ? [...value, highlighted] : [highlighted]);
              // TODO: Figure out why js-dom doesn't add a `scrollTo` function here
              if (typeof ((_optionsRef$current = optionsRef.current) === null || _optionsRef$current === void 0 ? void 0 : _optionsRef$current.scrollTo) === 'function') (_optionsRef$current2 = optionsRef.current) === null || _optionsRef$current2 === void 0 ? void 0 : _optionsRef$current2.scrollTo(0, 0);
              if (!multiple) {
                var _inputRef$current;
                dispatch({
                  type: 'collapse-options'
                });
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.blur();
              }
            }
            break;
          }
        case 'Escape':
          dispatch({
            type: 'collapse-options'
          });
          (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.blur();
          break;
      }
    }
    if (state.isExpanded) window.addEventListener('keydown', handleKeyDown);
    return () => {
      if (state.isExpanded) window.removeEventListener('keydown', handleKeyDown);
    };
    // Use the hash of `value` instead of the `value` prop itself
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, makeSelectedVisible, onChange, state, __value]);

  /**
   * Blur the entire field if there is a click outside of the component.
   */
  (0, _react.useEffect)(() => {
    function handleWindowClick(event) {
      const target = event.target;
      const current = containerRef.current;
      if (current && !(current.isSameNode(target) || current.contains(target))) {
        var _inputRef$current3;
        dispatch({
          type: 'collapse-options'
        });
        (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.blur();
      }
    }
    if (state.isExpanded) window.addEventListener('click', handleWindowClick);
    return () => {
      if (state.isExpanded) window.removeEventListener('click', handleWindowClick);
    };
  }, [dispatch, state]);

  /**
   * Callback for when the value of the `SearchText` component has changed.
   */
  function handleChange({
    target
  }) {
    dispatch({
      payload: target.value,
      type: 'change-search-text'
    });
  }

  /**
   * Callback for when the `Container` component is clicked. It expandes the options listbox and also focuses the
   * the search input.
   */
  function handleContainerClick() {
    var _inputRef$current4;
    if (!state.isExpanded) {
      dispatch({
        type: 'expand-options'
      });
    }
    (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.focus();
  }

  /**
   * Callback for when the `Expander` component is clicked. It makes sure that the event does _not_ bubble up which
   * would fire the callback for the `Container` component.
   */
  function handleExpanderClick(event) {
    if (state.isExpanded) {
      var _inputRef$current5;
      event.stopPropagation();
      dispatch({
        type: 'collapse-options'
      });
      (_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.blur();
    }
  }

  /**
   * Callback for when the `SearchText` component get focused.
   */
  function handleFocus() {
    if (!state.isExpanded) {
      dispatch({
        type: 'expand-options'
      });
    }
  }
  function handleSelectedOptionClick(option) {
    const updated = value.filter(({
      key
    }) => key !== option.key);
    if (onChange) onChange(updated);
  }

  /**
   * Callback for when an `Option` is clicked, which means that the option is now selected.
   */
  function handleOptionClick(option) {
    return event => {
      event.preventDefault();
      if (onChange) {
        var _optionsRef$current3, _optionsRef$current4;
        onChange(multiple ? [...value, option] : [option]);
        // TODO: Figure out why js-dom doesn't add a `scrollTo` function here
        if (typeof ((_optionsRef$current3 = optionsRef.current) === null || _optionsRef$current3 === void 0 ? void 0 : _optionsRef$current3.scrollTo) === 'function') (_optionsRef$current4 = optionsRef.current) === null || _optionsRef$current4 === void 0 ? void 0 : _optionsRef$current4.scrollTo(0, 0);
        if (!multiple) {
          var _inputRef$current6;
          dispatch({
            type: 'collapse-options'
          });
          (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 ? void 0 : _inputRef$current6.blur();
        }
      }
    };
  }
  return /*#__PURE__*/_react.default.createElement(Container, {
    "aria-disabled": disabled,
    "aria-expanded": state.isExpanded,
    "aria-haspopup": "listbox",
    "aria-owns": idRef.current,
    "data-testid": testID,
    onClick: handleContainerClick,
    ref: containerRef,
    role: "combobox"
  }, /*#__PURE__*/_react.default.createElement(Control, null, /*#__PURE__*/_react.default.createElement(InputArea, null, /*#__PURE__*/_react.default.createElement(Selection, null, value.map(v => multiple ? /*#__PURE__*/_react.default.createElement(SelectedOption, {
    key: v.key,
    onClick: handleSelectedOptionClick,
    value: v
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, v.text)), !!placeholder && state.isPlaceholderVisible && /*#__PURE__*/_react.default.createElement(Placeholder, {
    "aria-atomic": "true",
    "aria-live": "polite",
    role: "alert"
  }, placeholder), /*#__PURE__*/_react.default.createElement(SearchText, {
    "aria-autocomplete": "list",
    autoComplete: "off",
    onChange: handleChange,
    onFocus: handleFocus,
    ref: inputRef,
    tabIndex: 0,
    type: "text",
    value: state.searchText
  }))), /*#__PURE__*/_react.default.createElement(Expander, {
    "aria-label": `${state.isExpanded ? 'Hide' : 'Show'} options`,
    onClick: handleExpanderClick,
    role: "button",
    tabIndex: -1
  }, multiple ? /*#__PURE__*/_react.default.createElement(_symbols.ExpandVertical, {
    color: "dimGrey",
    size: 1
  }) : /*#__PURE__*/_react.default.createElement(_symbols.TriangleDown, {
    color: "dimGrey",
    size: 1,
    variant: "solid"
  }))), /*#__PURE__*/_react.default.createElement(Options, {
    "aria-multiselectable": "true",
    id: idRef.current,
    ref: optionsRef,
    role: "listbox"
  }, state.filteredOptions.length === 0 && /*#__PURE__*/_react.default.createElement(NoResults, null, "No results found."), state.filteredOptions.map((option, i) => /*#__PURE__*/_react.default.createElement(Option, {
    "aria-checked": value.map(v => v.key).includes(option.key),
    "aria-selected": state.highlightedFilteredOptionIndex === i,
    key: option.key,
    onClick: handleOptionClick(option),
    role: "option"
  }, option.text))));
}

//
// Private components
// -------------------------------------------------------------------------------------------------

function SelectedOption({
  value,
  onClick
}) {
  function handleClick(event) {
    event.preventDefault();
    onClick(value);
  }
  return /*#__PURE__*/_react.default.createElement(Selected, null, value.text, /*#__PURE__*/_react.default.createElement(CloseButton, {
    "aria-label": `Remove ${value.text}`,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_symbols.Close, {
    color: "dimGrey",
    size: 0
  })));
}